// extracted by mini-css-extract-plugin
module.exports = {"PopInCloseIcon":"styles_PopInCloseIcon__ssvUd","close":"styles_close__X7_t5","PopIn":"styles_PopIn__Wa6CH"};